
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-kepala-skb/pegawai/panduan/perilaku-kerja",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-kepala-skb/pegawai/panduan/perilaku-kerja.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-kepala-skb/pegawai/panduan/perilaku-kerja"])
      });
    }
  